module.exports = __webpack_public_path__ + "static/media/That-Pixabay-Traveller.0db49b24.png";